import React from "react";
import { Plus, Minus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqData = [{
  question: "What insurance plans do you accept?",
  answer: "Freetown Family Clinic accepts a wide range of providers, including major private insurance and community-based plans. We recommend contacting our front desk or your insurance representative to confirm coverage for specific preventive or diagnostic services."
}, {
  question: "How do I schedule a pediatric check-up?",
  answer: "You can schedule pediatric appointments through our patient portal or by calling us during business hours. We offer dedicated morning slots for well-child visits to ensure your little ones receive timely, personalized care in a calm environment."
}, {
  question: "Do I need a referral for chronic disease management?",
  answer: "While many of our primary care services are accessible directly, some specialized chronic care programs may require a referral depending on your insurance policy. Our team can help navigate these requirements during your initial consultation."
}, {
  question: "What should I bring to my first clinic visit?",
  answer: "For your first appointment, please bring a valid photo ID, your insurance card, and any current medications. If you are transferring care, bringing past medical records or immunization history for children is extremely helpful."
}, {
  question: "How can I access my lab results or medical records?",
  answer: "Your health information is securely available 24/7 through our digital portal and will be provided upon patient request. For sensitive results, a member of our medical team will often call you directly to discuss the findings and answer any immediate questions."
}];
export default function SpecialtyFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="19625" id="common-questions" ref={ref} className={`py-20 bg-background transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-serif font-medium text-foreground mb-4 tracking-tight">
            Common Questions
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Find clarity on insurance, pediatric care, and clinic procedures to 
            ensure your family's visit is as smooth and comfortable as possible.
          </p>
        </div>

        <div className="bg-accent/20 backdrop-blur-sm rounded-2xl p-6 md:p-8 shadow-xl border border-border/50">
          <Accordion type="single" collapsible className="w-full">
            {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b border-border last:border-0" data-index={i}>
                <AccordionTrigger className="text-left text-base md:text-lg font-bold text-foreground hover:bg-primary/5 hover:text-primary px-4 rounded-lg transition-colors duration-300 [&[data-state=open]]:text-primary [&[data-state=open]]:bg-primary/5">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed px-4 pb-6 pt-2">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-10 text-center">
          <p className="text-muted-foreground mb-4">
            Still have questions? Call us directly.
          </p>
          <Button asChild variant="default" size="lg" className="rounded-full bg-primary text-primary-foreground hover:shadow-lg transition-shadow duration-300">
            <Link to="/ContactPage">Contact Our Team</Link>
          </Button>
        </div>
      </div>
    </section>;
}